import React from 'react'
import './Service.css'
import serimg from './service-img/Firefly_20250108145339-removebg-preview.png'
import icon1 from './service-img/ic-1.png'
import icon2 from './service-img/ic-2.png'
import icon3 from './service-img/ic-3.png'
import icon4 from './service-img/ic-4.png'

const Service = () => {
    return (
        <div className='service-main' id='service'>
            <div className="service">
                <div className="service-head" data-aos="fade-up">
                    <p >Our Service</p>
                    <div className="service-line"></div>
                </div>
            </div>
            <div className="service-content-main">
                <div className="service-content-img" data-aos="fade-up">
                    <img src={serimg} alt="" />
                </div>
                <div className="service-content">
                    <div className="service-content-box" data-aos="fade-up">
                        <div className="service-box-icon">
                            <img src={icon1} alt="" />
                        </div>
                        <div className="survice-box-head">
                            <p>Installation & Commissioning</p>
                        </div>
                        <div className="service-box-content">
                            <p> Expert setup of charging infrastructure, including wiring, equipment installation, and 
                            integration with existing electrical systems</p>
                        </div>
                    </div>
                    <div className="service-content-box" data-aos="fade-up">
                        <div className="service-box-icon">
                            <img src={icon2} alt="" />
                        </div>
                        <div className="survice-box-head">
                            <p>Smart Management Solutions</p>
                        </div>
                        <div className="service-box-content">
                            <p> Advanced network management tools for real-time monitoring, usage analytics, 
                            payment systems, and remote troubleshooting</p>
                        </div>
                    </div>
                    <div className="service-content-box" data-aos="fade-up">
                        <div className="service-box-icon">
                            <img src={icon3} alt="" />
                        </div>
                        <div className="survice-box-head">
                            <p>Maintenance & Technical Support</p>
                        </div>
                        <div className="service-box-content">
                            <p>Regular inspections, preventive maintenance, and 24/7 technical support to 
                            ensure reliable operation and minimize downtime.</p>
                        </div>
                    </div>
                    <div className="service-content-box" data-aos="fade-up">
                        <div className="service-box-icon">
                            <img src={icon4} alt="" />
                        </div>
                        <div className="survice-box-head">
                            <p>Customized Charging Solutions</p>
                        </div>
                        <div className="service-box-content">
                            <p> Tailoring charging station designs and features to meet specific needs, whether for 
                            residential, commercial, or public use.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Service